import type { TConsoleState } from './types'

export const initialState: TConsoleState = {
  lines: [],
}
